
const Card2Style = {
  card: {
    boxShadow: 'none',
    maxWidth:'350px',
    margin: '0 auto'
  },
  subtitleContainer: {
    marginBottom: '15px'
  },
  image: {
    width: '160px',
    height: '250px'
  }
};

export default Card2Style
